<app-entity-mat-dialog-title *ngIf="dialogRef" title="Session Start Times"></app-entity-mat-dialog-title>
<div [class.mat-dialog-content]="dialogRef">
  <app-success-message *ngIf="!dialogRef" [message]="successMessage"></app-success-message>
  <app-error-message *ngIf="!dialogRef" [message]="errorMessage"></app-error-message>

  <mat-accordion class="sst-accordion" multi>
    <mat-expansion-panel *ngFor="let day of weekDays; let i = index" [expanded]="false" class="sst-panel">
      <mat-expansion-panel-header collapsedHeight="56px" expandedHeight="56px">
        <mat-panel-title class="sst-panel-title">
          <span class="sst-day-name">{{ day.name }}</span>
          <span class="sst-count" *ngIf="day.times.length > 0">
            {{ day.times.length }} {{ day.times.length === 1 ? 'time' : 'times' }}
          </span>
          <span class="sst-count sst-count--muted" *ngIf="!loadingTimes && day.times.length === 0">None set</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!-- Selected times -->
      <div class="sst-section">
        <span class="sst-section-label">Selected start times</span>
        <div class="sst-selected" *ngIf="day.times.length > 0">
          <button type="button"
                  *ngFor="let time of day.times"
                  class="sst-chip sst-chip--selected"
                  (click)="removeTime(day, convertTo12HourFormat(time))"
                  matTooltip="Remove"
                  [@chipAnimation]>
            {{ convertTo12HourFormat(time) }}
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <p class="sst-empty" *ngIf="!loadingTimes && day.times.length === 0">
          No start times selected for {{ day.name }} yet. Pick from the list below.
        </p>
      </div>

      <!-- Available times -->
      <div class="sst-section">
        <span class="sst-section-label">Add a start time</span>
        <div class="sst-available">
          <button type="button"
                  *ngFor="let time of getFilteredAvailableTimes(day)"
                  class="sst-chip"
                  (click)="addTime(day, time)"
                  [@chipAnimation]>
            {{ convertTo12HourFormat(time) }}
          </button>
        </div>
      </div>

      <!-- Per-day actions -->
      <div class="sst-day-actions">
        <button type="button" mat-stroked-button class="sst-day-btn" (click)="clearTimes(day)">
          <mat-icon>delete_outline</mat-icon> Clear all
        </button>
        <button type="button" mat-stroked-button class="sst-day-btn" (click)="copyToNextDays(i)">
          <mat-icon>arrow_downward</mat-icon> Copy to following days
        </button>
        <button type="button" mat-stroked-button class="sst-day-btn" (click)="copyToAllWeekdays(i)">
          <mat-icon>date_range</mat-icon> Copy to weekdays
        </button>
        <button type="button" mat-stroked-button class="sst-day-btn" (click)="copyLastDay(i)" [disabled]="i === 0">
          <mat-icon>content_copy</mat-icon> Copy previous day
        </button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<mat-dialog-actions *ngIf="dialogRef" align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="saveChanges()" [disabled]="showProgressSpinner">
    <mat-spinner *ngIf="showProgressSpinner" diameter="20" class="d-inline-block"></mat-spinner>
    <span *ngIf="!showProgressSpinner">Save</span>
  </button>
</mat-dialog-actions>

<div *ngIf="!dialogRef" class="d-flex justify-content-end mt-3">
  <button mat-raised-button color="primary" (click)="saveChanges()" [disabled]="showProgressSpinner">
    <mat-spinner *ngIf="showProgressSpinner" diameter="20" class="d-inline-block"></mat-spinner>
    <span *ngIf="!showProgressSpinner">Save Session Times</span>
  </button>
</div>
